const getLocationMessage = function () {
  let hasNewTradeIn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let dealNotifications = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let location = '';
  // The total property drives the number indicator on the header wallet icon
  const hasDealNotifications = dealNotifications?.total || 0;
  // Can contain other notification types that may not add to the wallet icon indicator number
  const dealNotificationsLength = Object.keys(dealNotifications).length;
  if (hasNewTradeIn && !hasDealNotifications) {
    location = 'header-trade-in';
  } else if (hasNewTradeIn && hasDealNotifications || dealNotificationsLength > 2) {
    location = 'header-multiple-updates';
  } else if (!hasNewTradeIn && dealNotificationsLength) {
    location = 'header-financing';
  }
  return location;
};
export { getLocationMessage as default };
